import React, { useState, useEffect } from "react";
import "../../pages/forms/form5.css";

const BASE_URL =
  "https://kovaikongunadumatrimony.com/kkm_admin/public/assets/prof_images/";
const HOROSCOPE_URL =
  "https://kovaikongunadumatrimony.com/kkm_admin/public/assets/horoscope_images/";

const EditForm5 = ({ formData, setFormData, setStep }) => {
  const [errors, setErrors] = useState({});
  const [preview, setPreview] = useState({
    profilePhoto1: "",
    profilePhoto2: "",
    horoscopePhoto: "",
  });

  // Whenever formData changes (from API or reset), rebuild previews
  useEffect(() => {
    const next = {};

    // Map each key to its correct base URL
    const urlMap = {
      profilePhoto1: BASE_URL,
      profilePhoto2: BASE_URL,
      horoscopePhoto: HOROSCOPE_URL,
    };

    Object.entries(urlMap).forEach(([key, urlBase]) => {
      const value = formData[key];
      if (!value) {
        next[key] = "";
      } else if (value instanceof File) {
        next[key] = URL.createObjectURL(value);
      } else {
        // string filename -> show from server
        next[key] = urlBase + value;
      }
    });

    setPreview(next);

    // Cleanup object URLs when unmounted
    return () => {
      Object.values(next).forEach((url) => {
        if (url && url.startsWith("blob:")) URL.revokeObjectURL(url);
      });
    };
  }, [formData]);

  const handleChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.profilePhoto1) newErrors.profilePhoto1 = "required";
    if (!formData.horoscopePhoto) newErrors.horoscopePhoto = "required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (validate()) setStep(6);
  };

  const handleBack = () => setStep(4);

  return (
    <div className="form5-background">
      <div className="form5-section">
        <h2 className="form5-title">Upload Photos (5/7)</h2>
        <form>
          <div className="form5-row">
            {/* Profile Photo 1 */}
            <div className="form5-group">
              <label>
                Profile Photo 1 <span className="error fs-star">*</span>
              </label>
              <input type="file" name="profilePhoto1" onChange={handleChange} />
              {preview.profilePhoto1 && (
                <div className="preview">
                  <img src={preview.profilePhoto1} alt="Profile 1" width={100} />
                </div>
              )}
              {errors.profilePhoto1 && (
                <span className="error-text">{errors.profilePhoto1}</span>
              )}
            </div>

            {/* Profile Photo 2 */}
            <div className="form5-group margin-align">
              <label>Profile Photo 2</label>
              <input type="file" name="profilePhoto2" onChange={handleChange} />
              {preview.profilePhoto2 && (
                <div className="preview">
                  <img src={preview.profilePhoto2} alt="Profile 2" width={100} />
                </div>
              )}
            </div>

            {/* Horoscope Photo */}
            <div className="form5-group">
              <label>
                Horoscope Photo <span className="error fs-star">*</span>
              </label>
              <input type="file" name="horoscopePhoto" onChange={handleChange} />
              {preview.horoscopePhoto && (
                <div className="preview">
                  <img src={preview.horoscopePhoto} alt="Horoscope" width={100} />
                </div>
              )}
              {errors.horoscopePhoto && (
                <span className="error-text">{errors.horoscopePhoto}</span>
              )}
            </div>
          </div>

          <div className="form5-btn-group">
            <button type="button" className="back-btn-5" onClick={handleBack}>
              Back
            </button>
            <button
              type="button"
              onClick={handleNext}
              className="submit-btn-5"
            >
              Continue
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditForm5;
